export const InitialValuesProfilePassword = {
  oldPassword: "",
  newPassword: "",
  newPasswordConfirm: "",
};
